export default __webpack_public_path__ + "static/media/icon_remove.3c662b75.png";